import React, {Fragment} from 'react';
import {connect} from "react-redux";

import {setShowJobPurchaseOrderPopup} from "../../actions/A_Popups";
import {PURCHASE_ORDER_CONTENT} from "./jobPurchaseOrderPopup/jobPurchaseOrderReducer";
import {getParsedJobOrder} from "./jobPurchaseOrderPopup/jobOrderFunctions";
import {getCurrentFabricatorId} from "../../utilities";
import {downloadFile} from "../../utilities/download";


const JobBoardOrderPurchaseButton = (props) => {

  const {job, setShowJobPurchaseOrderPopup, fabricatorId} = props;

  const jobOrder = getParsedJobOrder(job); // jobOrderInterface

  if (!jobOrder.childFabricatorId) { // no associated fabricator
    return null;
  }

  if (jobOrder.isPaid) { // the process is finished, well done
    return (
      <div className="p-1 text-center border-aqua2 color-aqua2 bold border-box mr-15 radius-6">
        This Job has been paid.
      </div>
    )
  }

  const isParentJob = jobOrder.parentFabricatorId === fabricatorId;
  const isChildrenJob = job.isRelated && (jobOrder.childFabricatorId === fabricatorId);

  const renderPurchaseOrderButton = () => {
    if (jobOrder.orderId) {
      return (
        <p className="m-0 color-light">
          Purchase Order ID: {jobOrder.orderFileUrl
          ? <span className="bold link link--green link--green-hover"
                  onClick={() => downloadFile(jobOrder.orderFileUrl, jobOrder.orderId)}>{jobOrder.orderId}</span>
          : <span className="bold color-white">{jobOrder.orderId}</span>}
        </p>
      )
    }
    if (!isParentJob || isChildrenJob) {
      return null // 1) only parent can create
    }
    return (
      <div className="text-center">
        <button className={"ui-button5 ui-button5--green mt-05"}
                onClick={() => setShowJobPurchaseOrderPopup(true, job)}
                disabled={false}>
          Generate Purchase Order
        </button>
      </div>
    )
  }

  const renderInvoiceButton = () => {
    if (jobOrder.invoiceId) {
      return (
        <p className="m-0 color-light">
          Invoice ID: {jobOrder.invoiceFileUrl
          ? <span className="bold link link--green link--green-hover"
                  onClick={() => downloadFile(jobOrder.invoiceFileUrl, jobOrder.invoiceId)}>{jobOrder.invoiceId}</span>
          : <span className="bold color-white">{jobOrder.invoiceId}</span>}
        </p>
      )
    }
    if (!isChildrenJob || !jobOrder.orderId) {
      return null // 1) only children can create invoice 2) purchase order is not created yet
    }
    return (
      <div className="text-center">
        <button className={"ui-button5 ui-button5--green mt-05"}
                onClick={() => setShowJobPurchaseOrderPopup(true, job, PURCHASE_ORDER_CONTENT.purchaseOrderInvoice)}
                disabled={false}>
          Submit Invoice
        </button>
      </div>
    )
  }

  const renderPayButton = () => {
    if (!isParentJob || !jobOrder.orderId || !jobOrder.invoiceId) {
      return null // 1) only parent can pay 2) no purchase order 3) no invoice created
    }
    return (
      <div className="text-center">
        <button className={"ui-button5 ui-button4--red mt-05"}
                onClick={() => setShowJobPurchaseOrderPopup(true, job, PURCHASE_ORDER_CONTENT.purchaseOrderPay)}
                disabled={false}>
          Pay This Invoice
        </button>
      </div>
    )
  }

  return (
    <div className="mb-1">
      {renderPurchaseOrderButton()}
      {renderInvoiceButton()}
      {renderPayButton()}
    </div>
  )
};

const mapStateToProps = (state) => {
  const fabricatorId = getCurrentFabricatorId(state);
  return {
    fabricatorId,
  };
};

const mapDispatchToProps = {
  setShowJobPurchaseOrderPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobBoardOrderPurchaseButton)
